export default __webpack_public_path__ + "static/media/bg-02.62a7580e.png";